import React from 'react';
import classNames from 'classnames';
import { Avatar } from '@fiverr-private/fit';
import { useHeaderContext } from '../../modern/context/HeaderContext';

import styles from './style.module.scss';

const AvatarHeader = () => {
    const {
        user: { username, email, fullName, profileImage },
    } = useHeaderContext();
    const mainName = fullName || username;
    const secondaryName = fullName ? username : null;

    return (
        <div className="m-t-16 p-r-16 flex flex-items-center">
            <Avatar username={username} src={profileImage} size={40} />
            <div className="flex flex-col flex-justify-center m-l-12 tbody-6" style={{ minWidth: 0 }}>
                <span className={classNames('text-semi-bold flex', styles.fullname)}>
                    {mainName}&nbsp;
                    {secondaryName && <span className="text-trunc">({secondaryName})</span>}
                </span>
                <span className={classNames('text-trunc', styles.email)}>{email}</span>
            </div>
        </div>
    );
};

export default AvatarHeader;
